import { CustomerStatus } from '@/src/models/CustomersDto';
import { badgeColorData } from '@/components/atom/Badge';

export const getStatusBadgeProps = (
  type: CustomerStatus,
): {
  children: string;
  badgeColor: keyof typeof badgeColorData;
} => {
  switch (type) {
    case 'suspended':
      return {
        children: '정지 회원',
        badgeColor: 'lightRed',
      };
    case 'withdrawal':
      return {
        children: '탈퇴 회원',
        badgeColor: 'lightGray',
      };
    case 'normal':
      return {
        children: '일반 회원',
        badgeColor: 'lightYellow',
      };
    default:
      return {
        children: '-',
        badgeColor: 'lightGray',
      };
  }
};
